import {useMutation, useQueryClient} from '@tanstack/react-query';
import contractUpdaters from '@/api/updaters/contracts';

function useUpdateContractDueDate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['contracts', 'updateDueDate'],
    mutationFn: contractUpdaters.updateDueDate,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({queryKey: ['campaignV2CreatorsCounts']});
    },
  });
}

export default useUpdateContractDueDate;
